<template>
  <div class="landing-new__body">
    <section class="metrics">
      <div class="metrics__head">
        <h2 class="metrics__title">{{ $t('home.metrics.title') }}</h2>
      </div>
      <div class="metrics__grid">
        <div v-for="(item, index) in items" :key="item.label" class="metrics__col">
          <span class="metrics__value" :class="{ 'metrics__value--lg': index === 1 }">
            {{ item.value }}<sup>{{ item.suffix }}</sup>
          </span>
          <h3 class="metrics__label">{{ item.label }}</h3>
          <p class="metrics__desc">{{ item.description }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    items() {
      return [1, 2, 3].map((n) => ({
        value: this.$t(`home.metrics.value${n}`),
        suffix: this.$t(`home.metrics.suffix${n}`),
        label: this.$t(`home.metrics.label${n}`),
        description: this.$t(`home.metrics.desc${n}`),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics {
  padding: 80px 0;
}

.metrics__head {
  margin-bottom: 52px;
  text-align: center;
}

.metrics__title {
  font-size: 31px;
  font-weight: 700;
  color: #1b2733;
  letter-spacing: -0.4px;
  line-height: 1.15;
  margin: 0;
  text-align: center;
}

.metrics__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.metrics__col {
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }

  & + & {
    border-left: 1px solid rgba(27, 39, 51, 0.08);
  }
}

.metrics__value {
  display: block;
  font-size: 92px;
  font-weight: 900;
  color: #2a8aea;
  line-height: 1;
  letter-spacing: -3px;
  margin-bottom: 14px;
  white-space: nowrap;

  sup {
    display: inline-block;
    font-size: 42px;
    letter-spacing: 0;
    margin-left: 6px;
    position: relative;
    top: 2px;
    vertical-align: top;
  }
}

.metrics__label {
  font-size: 16px;
  font-weight: 700;
  color: #1b2733;
  margin: 0 0 8px;
  line-height: 1.2;
}

.metrics__desc {
  font-size: 13px;
  line-height: 1.57;
  color: rgba(27, 39, 51, 0.7);
  margin: 0;
}

@media (max-width: 1024px) {
  .metrics__col {
    padding: 0 40px;
  }
  .metrics__value {
    font-size: 72px;
    letter-spacing: -2.5px;
  }
  .metrics__value sup {
    font-size: 34px;
    margin-left: 5px;
  }
}

@media (max-width: 767px) {
  .metrics {
    padding: 60px 0;
  }
  .metrics__grid {
    grid-template-columns: 1fr;
  }

  .metrics__col {
    padding: 36px 0;
    border-left: none !important;
    border-top: none;
    text-align: center;
    align-items: center;

    &:first-child {
      padding-top: 0;
    }
  }

  .metrics__value {
    font-size: 72px;
    letter-spacing: -2.5px;
  }
}
</style>
